import {findIndex} from "lodash";

export default {
    methods: {

        configurationSetCurrentConfiguration(userGroup, user, device) {

            let self = this;

            let found = self.configurations.some(c => {

                if (c.value.device === device && c.value.user === user && c.value.user_group === userGroup) {
                    self.currentSelectedConfiguration = c.key
                    self.currentSelectedConfigurationIndex = findIndex(self.configurations, {key: c.key})
                    return true
                }

                return false;

            })

            if (found) {
                self.loadAModelIfWeHaveIt();
            }

        },

        /**
         *
         * Returns the first configuration that matches the userGroup, user and device
         *
         * @param userGroup
         * @param user
         * @param device
         * @returns {boolean}
         */
        configurationGetCurrentConfiguration(userGroup, user, device) {

            let self = this;

            let configurationName = false;

            self.configurations.some(c => {

                if (c.value.device === device && c.value.user === user && c.value.user_group === userGroup) {
                    configurationName = c.key
                    return true
                }

                return false;

            })

            return configurationName

        },

        /**
         *
         * This method will return all the configurations that match the userGroup, supplying user and device is optional.
         * This function will get the configurations smartly, if user and device are missing, a broader range of cnofigurations matching the userGroup will be returned.
         *
         * @param userGroup
         * @param user
         * @param device
         */
        configurationGetAllConfigurations(userGroup, user = false, device = false) {

            let self = this;

            let configurations = [];

            self.configurations.forEach(c => {

                if (c.value.user_group === userGroup) {

                    if (user && device) {
                        if (c.value.device === device && c.value.user === user) {
                            configurations.push(c.key);
                        }
                    } else if (user) {
                        if (c.value.user === user) {
                            configurations.push(c.key);
                        }
                    } else {
                        configurations.push(c.key);
                    }

                }

            })

            return configurations


        },

        configurationCurrentReset() {

            const self = this

            self.currentSelectedConfiguration = ''
            self.currentSelectedConfigurationIndex = -1
            self.chosenModel = ''

        },

        loadAModelIfWeHaveIt() {

            const self = this
            const models = self.modelsForSelectedConfiguration()

            if (models?.length > 0) {
                self.chosenModel = models[0]
                self.phoneTypeIndex = findIndex(self.phoneTypes, {key: self.chosenModel})
            }

        },

        modelsForSelectedConfiguration() {

            let self = this
            let models = false

            if (self.currentSelectedConfiguration) {

                const phoneModel = self.configurations[self.currentSelectedConfigurationIndex].value.phone_model

                /*if (typeof phoneModel !== 'undefined' && phoneModel && Object.keys(phoneModel).length > 0) {
                    models = Object.keys(phoneModel)
                }*/

                models = [phoneModel]

            }

            return models

        },

        configurationBulkDelete(userGroup, user = false, device = false) {

            let self = this;

            let configurationsToDelete = self.configurationGetAllConfigurations(userGroup, user, device)

            configurationsToDelete.forEach(c => {
                self.resetIfCurrentConfigurationIsDeleted(c)
                self.configurationDelete(c)
            })

        },

        /**
         *
         * @param userGroup
         * @param user
         * @param device
         * @returns {*|boolean}
         */
        configurationDeleteByDeviceDetails(userGroup, user = false, device = false) {

            let self = this;

            let configurationNameToDelete = self.configurationGetCurrentConfiguration(userGroup, user, device)

            if (configurationNameToDelete) {
                self.resetIfCurrentConfigurationIsDeleted(configurationNameToDelete)
                return self.configurationDelete(configurationNameToDelete)
            }

            return false;

        },

        resetIfCurrentConfigurationIsDeleted(configurationNameToDelete) {

            let self = this;

            if (self.currentSelectedConfiguration === configurationNameToDelete) {
                self.configurationCurrentReset()
            }

        },

        configurationDelete(configurationName) {

            let self = this;

            const configurationIndex = findIndex(self.configurations, function (o) {
                return o.key === configurationName
            })

            if (configurationIndex !== -1) {
                return self.configurations.splice(configurationIndex, 1)
            }

            return false
        },

        configurationResetCurrent() {

            let self = this;

            self.currentSelectedConfiguration = ''
            self.currentSelectedConfigurationIndex = -1
            self.chosenModel = ''
            self.phoneTypeIndex = -1

        }

    }
}
